module.exports = __webpack_public_path__ + "media/images/common/post_kuchikomi_btn_s-c5c3afa82c6fdf708aa68cbdc2e21ca1.png";